import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import noImageUrl from 'assets/noimage.png';

const Media = () => {
  const {
    BidStore: { auction },
  } = useStores();

  const { url } = auction;

  return url ? <img src={url} alt="" /> : <img src={noImageUrl} alt="" width={300} border="0" />;
};

export default observer(Media);
